import { render, staticRenderFns } from "./ChartMessagesGenders.vue?vue&type=template&id=5dcf753f"
import script from "./ChartMessagesGenders.vue?vue&type=script&lang=js"
export * from "./ChartMessagesGenders.vue?vue&type=script&lang=js"
import style0 from "./ChartMessagesGenders.vue?vue&type=style&index=0&id=5dcf753f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports